module.exports = __webpack_public_path__ + "static/img/IO.79bb5f4f.svg";